import { createPortalSlot } from "../portal-slot/createPortalSlot"

/**
 * Drawer.Footer as a portal slot for panel form actions.
 *
 * Built on `createPortalSlot` — see that module for the generic contract and
 * how to extend to multiple targets in one tree.
 */
const augmentationPanelFooterSlot = createPortalSlot("augmentation_footer")

export const AugmentationPanelFooterProvider =
  augmentationPanelFooterSlot.Provider

/** Callback ref for `Drawer.Footer`. Must be used under the Provider. */
export const useAugmentationPanelFooterHostRef =
  augmentationPanelFooterSlot.useHostRef

/** Footer host node, or null outside the panel / before mount. */
export const useAugmentationPanelFooterTarget =
  augmentationPanelFooterSlot.useTarget

/** Portals children into Drawer.Footer when the panel provides one. */
export const AugmentationPanelFooterPortal = augmentationPanelFooterSlot.Portal
